"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCHEDULED_JOIN_LEAD_MS = exports.SCHEDULED_MEETING_WINDOW_MS = exports.GRID_WIDTH = void 0;
exports.parseRoomName = parseRoomName;
exports.isOffice = isOffice;
exports.createDefaultRooms = createDefaultRooms;
exports.getFreeSpace = getFreeSpace;
exports.getFreePosition = getFreePosition;
exports.checkIntersection = checkIntersection;
exports.isScheduledJoinable = isScheduledJoinable;
exports.getFreeRoomPlace = getFreeRoomPlace;
const core_1 = require("@hcengineering/core");
const plugin_1 = __importDefault(require("./plugin"));
const types_1 = require("./types");
/**
 * Splits `${workspaceUuid}_${meetingMinutesId}` from `getRoomName`. Neither id ever contains
 * `_`, so the first one is always the separator.
 */
function parseRoomName(roomName) {
    const sepIdx = roomName.indexOf('_');
    if (sepIdx <= 0 || sepIdx === roomName.length - 1)
        return undefined;
    return {
        workspace: roomName.slice(0, sepIdx),
        meetingId: roomName.slice(sepIdx + 1)
    };
}
exports.GRID_WIDTH = 15;
function isOffice(room) {
    return room.person !== undefined;
}
function createDefaultRooms(employees, defaultTranscription = false, defaultRecording = false, defaultPrivate = false) {
    const res = [];
    // create 12 offices
    for (let index = 0; index < 12; index++) {
        const _id = (0, core_1.generateId)();
        const office = {
            _id,
            name: '',
            type: types_1.RoomType.Video,
            floor: plugin_1.default.ids.MainFloor,
            width: 2,
            height: 1,
            x: (index % 2) * 3,
            y: index - (index % 2),
            person: employees[index] ?? null,
            language: 'en',
            startWithTranscription: false,
            startWithRecording: false,
            startPrivate: true,
            description: null
        };
        res.push(office);
    }
    const allHands = (0, core_1.generateId)();
    res.push({
        _id: allHands,
        name: 'All hands',
        type: types_1.RoomType.Video,
        floor: plugin_1.default.ids.MainFloor,
        width: 9,
        height: 3,
        x: 6,
        y: 0,
        language: 'en',
        startWithTranscription: defaultTranscription,
        startWithRecording: defaultRecording,
        startPrivate: defaultPrivate,
        description: null
    });
    const meetingRoom1 = (0, core_1.generateId)();
    res.push({
        _id: meetingRoom1,
        name: 'Meeting Room 1',
        type: types_1.RoomType.Video,
        floor: plugin_1.default.ids.MainFloor,
        width: 4,
        height: 3,
        x: 6,
        y: 4,
        language: 'en',
        startWithTranscription: defaultTranscription,
        startWithRecording: defaultRecording,
        startPrivate: defaultPrivate,
        description: null
    });
    const meetingRoom2 = (0, core_1.generateId)();
    res.push({
        _id: meetingRoom2,
        name: 'Meeting Room 2',
        type: types_1.RoomType.Video,
        floor: plugin_1.default.ids.MainFloor,
        width: 4,
        height: 3,
        x: 11,
        y: 4,
        language: 'en',
        startWithTranscription: defaultTranscription,
        startWithRecording: defaultRecording,
        startPrivate: defaultPrivate,
        description: null
    });
    const voiceRoom1 = (0, core_1.generateId)();
    res.push({
        _id: voiceRoom1,
        name: 'Voice Room 1',
        type: types_1.RoomType.Audio,
        floor: plugin_1.default.ids.MainFloor,
        width: 4,
        height: 3,
        x: 6,
        y: 8,
        language: 'en',
        startWithTranscription: false,
        startWithRecording: false,
        startPrivate: false,
        description: null
    });
    const voiceRoom2 = (0, core_1.generateId)();
    res.push({
        _id: voiceRoom2,
        name: 'Voice Room 2',
        type: types_1.RoomType.Audio,
        floor: plugin_1.default.ids.MainFloor,
        width: 4,
        height: 3,
        x: 11,
        y: 8,
        language: 'en',
        startWithTranscription: false,
        startWithRecording: false,
        startPrivate: false,
        description: null
    });
    return res;
}
const cropMaxWidth = (width) => {
    return width > exports.GRID_WIDTH ? exports.GRID_WIDTH : width;
};
function getFreeSpace(rooms, exclude, completeExclusion) {
    const sorted = [...rooms].sort((a, b) => a.y - b.y);
    const map = [new Array(exports.GRID_WIDTH).fill(true)];
    for (const room of sorted) {
        const excluded = exclude?._id === room._id;
        for (let y = room.y === 0 ? 0 : excluded ? room.y : room.y - 1; y < room.y + room.height + (excluded ? 0 : 1); y++) {
            map[y] ??= new Array(exports.GRID_WIDTH).fill(true);
            for (let x = room.x === 0 ? 0 : excluded ? room.x : room.x - 1; x <
                (room.x + room.width - 1 < exports.GRID_WIDTH
                    ? excluded
                        ? cropMaxWidth(room.x + room.width)
                        : cropMaxWidth(room.x + room.width + 1)
                    : exports.GRID_WIDTH - 1); x++) {
                map[y][x] = completeExclusion === true && excluded;
            }
        }
    }
    map.push(new Array(exports.GRID_WIDTH).fill(true));
    return map;
}
function getFreePosition(rooms, width, height) {
    const map = getFreeSpace(rooms);
    for (let y = 0; y <= map.length; y++) {
        map[y] ??= new Array(exports.GRID_WIDTH).fill(true);
        for (let x = 0; x < map[y].length; x++) {
            if (map[y][x]) {
                let matched = true;
                for (let yIndex = 0; yIndex < height; yIndex++) {
                    if (map[y + yIndex] === undefined) {
                        map[y + yIndex] = new Array(exports.GRID_WIDTH).fill(true);
                    }
                    for (let xIndex = 0; xIndex < width; xIndex++) {
                        if (!map[y + yIndex][x + xIndex]) {
                            matched = false;
                            break;
                        }
                    }
                }
                if (matched) {
                    return {
                        x,
                        y
                    };
                }
            }
        }
    }
    return {
        x: 0,
        y: 0
    };
}
function checkIntersection(rooms, width, height, x, y) {
    for (const room of rooms) {
        if (x <= room.x + room.width && x + width >= room.x && y <= room.y + room.height && y + height >= room.y) {
            return true;
        }
    }
    return false;
}
// A scheduled meeting keeps its identity for a plausible session length: an empty room in the
// middle of it is a dropout, not the end. Joining opens 15 minutes before the start.
exports.SCHEDULED_MEETING_WINDOW_MS = 4 * 60 * 60 * 1000;
exports.SCHEDULED_JOIN_LEAD_MS = 15 * 60 * 1000;
// A Scheduled meeting owns its room only inside that window; next week's one must not swallow
// an ad-hoc Connect. Without a date there is no window, so it owns nothing.
function isScheduledJoinable(mm, now = Date.now()) {
    if (mm.status !== types_1.MeetingStatus.Scheduled)
        return false;
    const date = mm.meetingScheduledDate;
    if (date == null)
        return false;
    return now >= date - exports.SCHEDULED_JOIN_LEAD_MS && now < date + exports.SCHEDULED_MEETING_WINDOW_MS;
}
function getFreeRoomPlace(room, info, person, pref) {
    const taken = (x, y) => info.some((p) => p.x === x && p.y === y);
    if (pref !== undefined) {
        if (isOffice(room) && room.person === person) {
            return { x: 0, y: 0 };
        }
        // Only honour a preference that the floor grid can actually render.
        const inGrid = pref.x >= 0 && pref.y >= 0 && pref.x < room.width && pref.y < room.height;
        // (0,0) of an office belongs to its owner, who already returned above.
        const ownerSeat = isOffice(room) && pref.x === 0 && pref.y === 0;
        if (inGrid && !ownerSeat && !taken(pref.x, pref.y)) {
            return pref;
        }
    }
    for (let y = 0; y < room.height; y++) {
        for (let x = 0; x < room.width; x++) {
            if (taken(x, y))
                continue;
            // (0,0) of an office belongs to its owner.
            if (x === 0 && y === 0 && isOffice(room)) {
                if (room.person === person)
                    return { x: 0, y: 0 };
                continue;
            }
            return { x, y };
        }
    }
    // Room full: overflow along x - RoomPreview adds extra columns, never rows.
    for (let x = room.width;; x++) {
        if (!taken(x, 0))
            return { x, y: 0 };
    }
}
//# sourceMappingURL=utils.js.map